// @flow

import * as React from "react";

import type { InputType } from "../../Input/TextInput";

export type SelectionMode = "single" | "multi";

type TileListLogicProps = {
  input: InputType,
  selectionMode: SelectionMode,
  children: ({
    isActive: (currentValue: any) => boolean,
    handleClick: (selectedValue: any) => void
  }) => React.Node
};

class TileListLogic extends React.Component<TileListLogicProps> {
  isActive = (currentValue: any) => {
    const {
      input: { value: fieldValue },
      selectionMode
    } = this.props;

    switch (selectionMode) {
      case "single":
        return fieldValue === currentValue;
      case "multi":
        return Array.isArray(fieldValue) && fieldValue.includes(currentValue);
      default:
        return false;
    }
  };

  handleClick = (selectedValue: any) => {
    const {
      input: { onChange, onFocus, onBlur }
    } = this.props;

    const newValue = this.calculateNewValue(selectedValue);

    onChange(newValue);
    onFocus();
    onBlur();
  };

  calculateNewValue = (selectedValue: any) => {
    const {
      input: { value: currentValue },
      selectionMode
    } = this.props;

    let newValue = null;

    switch (selectionMode) {
      case "single": {
        newValue = currentValue === selectedValue ? "" : selectedValue;
        break;
      }
      case "multi": {
        if (Array.isArray(currentValue)) {
          newValue = currentValue.includes(selectedValue)
            ? currentValue.filter(value => value !== selectedValue)
            : [...currentValue, selectedValue];
        } else {
          newValue = [selectedValue];
        }

        break;
      }
      default:
    }

    return newValue;
  };

  getProps = () => ({
    isActive: this.isActive,
    handleClick: this.handleClick
  });

  render() {
    const { children } = this.props;

    return children(this.getProps());
  }
}

export default TileListLogic;
